import type { EnquirySiteVisit } from "./types/enquiry-site-visit.types";
import {
  getEnquirySiteVisitWorkflowFlags,
  type EnquirySiteVisitWorkflowFlags,
} from "./enquirySiteVisitWorkflow";

export type SiteVisitWorkflowUiVisibility = {
  showStart: boolean;
  showComplete: boolean;
  showCancel: boolean;
  showAnyWorkflow: boolean;
  flags: EnquirySiteVisitWorkflowFlags;
};

/** Start / complete: logged-in user is an employee (`useProfile().isEmployee`). */
export function getSiteVisitWorkflowUiVisibility(
  status: string | null | undefined,
  isEmployee: boolean,
): SiteVisitWorkflowUiVisibility {
  const flags = getEnquirySiteVisitWorkflowFlags(status, {
    allowStartCompleteForActor: isEmployee,
  });
  return {
    showStart: flags.canStart,
    showComplete: flags.canComplete,
    showCancel: flags.canCancel,
    showAnyWorkflow: flags.canStart || flags.canComplete || flags.canCancel,
    flags,
  };
}

export function guardSiteVisitStart(
  visit: EnquirySiteVisit,
  isEmployee: boolean,
): boolean {
  const { canStart } = getEnquirySiteVisitWorkflowFlags(visit.status, {
    allowStartCompleteForActor: isEmployee,
  });
  return canStart;
}

export function guardSiteVisitComplete(
  visit: EnquirySiteVisit,
  isEmployee: boolean,
): boolean {
  const { canComplete } = getEnquirySiteVisitWorkflowFlags(visit.status, {
    allowStartCompleteForActor: isEmployee,
  });
  return canComplete;
}

export function guardSiteVisitCancel(
  status: string | null | undefined,
  isEmployee: boolean,
) {
  return getEnquirySiteVisitWorkflowFlags(status, {
    allowStartCompleteForActor: isEmployee,
  }).canCancel;
}
